import React from 'react';
import PropTypes from 'prop-types';
import serialize from 'form-serialize';
import { Link } from 'react-router-dom';

import Button from '@prisjakt/ui-button';
import { Checkbox } from '@prisjakt/ui-inputs';
import { AppContext } from '@prisjakt/ui-app-context';

import SocialNetworks from '../components/social-networks';

import * as S from './styles';

class LoginPage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showPassword: false,
    };

    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    this.props.clearErrors(e.target.name);
  }

  handleCheckbox(e) {
    this.setState({
      [e.target.name]: e.target.checked,
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    const { username = '', loginPassword = '' } = serialize(e.target, {
      hash: true,
    });

    this.props.validate({ username, loginPassword }, () => {
      this.props.login({ username, password: loginPassword });
    });
  }

  render() {
    const { showPassword } = this.state;
    const { errors } = this.props;
    const { t } = this.context;

    return (
      <S.LoginPage>
        <S.Section>
          <S.Form
            method="post"
            onSubmit={e => {
              this.handleSubmit(e);
            }}
            noValidate
          >
            <S.EmailInput
              type="email"
              name="username"
              onChange={this.handleChange}
              label={t('account', 'input.email')}
              tabIndex="0"
              autoFocus
              warning={errors.username}
              helper={
                errors.username ? t('errors', errors.username[0].code) : null
              }
            />

            <S.PasswordInput
              type={showPassword ? 'text' : 'password'}
              name="loginPassword"
              onChange={this.handleChange}
              label={t('account', 'input.password')}
              tabIndex="0"
              warning={errors.loginPassword}
              helper={
                errors.loginPassword
                  ? t('errors', errors.loginPassword[0].code)
                  : null
              }
            >
              <Checkbox
                name="showPassword"
                label={t('account', 'input.password-toggle')}
                checked={showPassword}
                onChange={this.handleCheckbox}
                tabIndex="-1"
              />
            </S.PasswordInput>

            {errors.form && (
              <S.FormError>{t('errors', errors.form[0].code)}</S.FormError>
            )}

            <S.LoginButton
              style={{ width: '100%' }}
              loading={this.props.pending}
              text={t('account', 'login.submit-button')}
              color="positive"
            />

            <S.ForgotPasswordLink to="/forgot-password" tabIndex="-1">
              <S.LinkText>{t('account', 'login.forgot-password')}</S.LinkText>
            </S.ForgotPasswordLink>
          </S.Form>

          <S.Description>{t('account', 'login.description')}</S.Description>

          <Button
            component={<Link to="/signup" />}
            style={{ width: '100%' }}
            variant="outlined"
            color="primary"
          >
            {t('account', 'signup.submit-button')}
          </Button>
        </S.Section>

        <S.Section>
          <S.Spacer />
          <SocialNetworks
            action="login"
            styles={{ spacer: '' }}
            loading={this.props.socialPending}
            onAuthResponse={this.props.onSocialResponse}
            onAuthInit={this.props.onSocialInit}
          />

          {errors.socialNetworks && (
            <S.FormError>
              {t('errors', errors.socialNetworks[0].code)}
            </S.FormError>
          )}
        </S.Section>
      </S.LoginPage>
    );
  }
}

const { func, object, bool } = PropTypes;

LoginPage.propTypes = {
  login: func.isRequired,
  onSocialResponse: func.isRequired,
  onSocialInit: func.isRequired,
  validate: func.isRequired,
  pending: bool.isRequired,
  socialPending: bool.isRequired,
  errors: object.isRequired, // eslint-disable-line react/forbid-prop-types
  clearErrors: func.isRequired,
};

LoginPage.contextType = AppContext;

export default LoginPage;
